module.exports = __webpack_public_path__ + "static/39FEA2_4_0-9244b6a792822998ddc5b968737a08b8.woff2";